/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Bounded dashboard surface that opened setup.
 */
export const SourceSurface = {
  PlatformMcpSettings: "platform_mcp_settings",
  OrganizationSetup: "organization_setup",
  PlatformPlugins: "platform_plugins",
  SidebarFooter: "sidebar_footer",
  SourcesEmpty: "sources_empty",
  ProjectOverviewZeroData: "project_overview_zero_data",
  OrganizationHome: "organization_home",
} as const;
/**
 * Bounded dashboard surface that opened setup.
 */
export type SourceSurface = ClosedEnum<typeof SourceSurface>;

export type StartOnboardingRequestBody = {
  /**
   * Bounded dashboard surface that opened setup.
   */
  sourceSurface?: SourceSurface | undefined;
};

/** @internal */
export const SourceSurface$outboundSchema: z.ZodMiniEnum<typeof SourceSurface> =
  z.enum(SourceSurface);

/** @internal */
export type StartOnboardingRequestBody$Outbound = {
  source_surface?: string | undefined;
};

/** @internal */
export const StartOnboardingRequestBody$outboundSchema: z.ZodMiniType<
  StartOnboardingRequestBody$Outbound,
  StartOnboardingRequestBody
> = z.pipe(
  z.object({
    sourceSurface: z.optional(SourceSurface$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      sourceSurface: "source_surface",
    });
  }),
);

export function startOnboardingRequestBodyToJSON(
  startOnboardingRequestBody: StartOnboardingRequestBody,
): string {
  return JSON.stringify(
    StartOnboardingRequestBody$outboundSchema.parse(startOnboardingRequestBody),
  );
}
